import React, { Component } from 'react';
import { SpinnerButton } from './Spinner.js';
import UsersService from '../services/Users.js';
import { Link, Navigate } from 'react-router-dom';
import validator from 'validator';
import { withFirebase } from '../views/firebase';
import { API_ENDPOINT, SITE_LOGO, SITE_NAME } from '../services/Constants';
import Footer from './Footer.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import mierosVideo from '../assets/background/mieros.mp4'; // Adjust the import path if necessary
import logo from '../assets/AA-01.jpg';
import { CButton, CCard, CCardBody, CInputGroup, CInputGroupText, CForm, CFormLabel, CFormInput, CRow, CCol } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilUser, cilCalendar, cilCheckCircle } from '@coreui/icons';


class CreateAccount extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      user: {},
      formErrors: {},
      formTouched: false,
      fieldsTouched: [],
      address: "TBD",
      isValidForm: false,
      confirmPassword: null,
      isSuccessResponse: false,
      errorResponse: ""
    };

    this.users = new UsersService();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    document.title = SITE_NAME + ": Member registration";
  }


  handleBlur = async (event) => {
    //console.log("In handleBlur");
    const { name, value } = event.target;

    if (name === "userID" && value) {
      //console.log("In handleBlur1");
      const emailExists = await this.props.firebase.checkIfEmailExistsByFetch(value);
      console.log("In handleBlurCheck: " + emailExists + " " + value);
      this.setState((prevState) => {
        const formErrors = { ...prevState.formErrors };
        if (emailExists) {
          formErrors.userID = "Email already in use.";
          toast.success("User already exists. Use Google sign in to add wallet in profile ");
          this.setState({ isLoading: false, isSuccessResponse: true });
        } else {
          formErrors.userID = null;
        }
        return { formErrors };
      });
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => {
      const user = { ...prevState.user, [name]: value };
      if (name === "userID") {
        user.email = value;
      }
      const fieldsTouched = prevState.fieldsTouched.includes(name) ? prevState.fieldsTouched : [...prevState.fieldsTouched, name];
      return { user, fieldsTouched, formTouched: false };
    }, () => {
      this.formValidate(name, value);
    });
  };


  handleChangeold = async (event) => {
    const { name, value } = event.target;

    if (name === "userID" && value) {
      const emailExists = await this.props.firebase.checkIfEmailExists(value);

      this.setState((prevState) => {
        const user = { ...prevState.user, [name]: value };
        if (name === "userID") {
          user.email = value;
        }
        const fieldsTouched = prevState.fieldsTouched.includes(name) ? prevState.fieldsTouched : [...prevState.fieldsTouched, name];
        const formErrors = { ...prevState.formErrors };
        if (emailExists) {
          formErrors.userID = "Email already in use.";
          toast.success("User already exists. Use Google sign in to add wallet in profile ");
          this.setState({ isLoading: false, isSuccessResponse: true });
        } else {
          formErrors.userID = null;
        }
        return { user, fieldsTouched, formErrors, formTouched: false };
      }, () => {
        this.formValidate(name, value);
      });
    } else {
      this.setState((prevState) => {
        const user = { ...prevState.user, [name]: value };
        if (name === "userID") {
          user.email = value;
        }
        const fieldsTouched = prevState.fieldsTouched.includes(name) ? prevState.fieldsTouched : [...prevState.fieldsTouched, name];
        return { user, fieldsTouched, formTouched: false };
      }, () => {
        this.formValidate(name, value);
      });
    }
  };



  getUIDByEmail = async (email) => {
    try {
      const response = await fetch(`/getUserByEmail?email=${email}`);
      const data = await response.json();
      return data.uid;
    } catch (error) {
      toast.error('Error fetching user UID.');
      throw error;
    }
  };

  handleAuthentication = async (email, password) => {
    const existingUser = await this.props.firebase.auth.fetchSignInMethodsForEmail(email);
    if (existingUser.includes('password')) {
      // Sign in with email and password
      const userCredential = await this.props.firebase.auth.signInWithEmailAndPassword(email, password);
      return userCredential.user;
    } else if (existingUser.includes('google.com')) {
      // Sign in with Google
      const provider = new this.props.firebase.auth.GoogleAuthProvider();
      const result = await this.props.firebase.auth.signInWithPopup(provider);
      return result.user;
    } else {
      // Handle other sign-in methods
      // ...
    }
  };

  handleLinkGoogleAccount = async (email) => {
    console.log("Yo you have an email already logged in hableGoogleACcount");
    const { firebase } = this.props;
    // const provider = new firebase.googleProvider;

    // Sign in with Google
    // const result = await firebase.auth.signInWithPopup(provider);
    // const googleUser = result.user;

    // Check if the email matches
    // if (googleUser.email !== email) {
    //   return {
    //     success: false,
    //     message: 'Google account email does not match.',
    //   };
    // }

    // Link Google account with existing wallet
    const user = firebase.auth.currentUser;


    console.log("user: " + user);
    await user.linkWithPopup(new firebase.googleProvider);

    // Update wallet information if necessary
    // Create user with Firebase
    const { email: userEmail, password: userPassword, name: userName, phone: userPhone, userID } = this.state.user;
    const userCredential = await firebase.auth.createUserWithEmailAndPassword(userEmail, userPassword);
    console.log("here0");
    const firebaseUser = userCredential.user;
    let userType = "AH"; //or TRD for trader
    await firebaseUser.updateProfile({
      displayName: userName,
      phoneNumber: userPhone
    });
    console.log("here1");
    // Save user data to Firestore or Realtime Database
    await firebase.db.ref(`users/${firebaseUser.uid}`).set({
      email: userEmail,
      name: userName,
      phone: userPhone,
      address: "TBD",
      paymentID: "0",
      userID,
      password: userPassword,
      userType,
      mieUserID: firebaseUser.uid,
      verified: false,
    });

    return {
      success: true,
      message: 'Google account linked with existing wallet.',
    };
  };


  handleRegister = async (email, password, displayName) => {
    // Check if the email is already in use
    const existingUser = await this.props.firebase.auth.fetchSignInMethodsForEmail(email);
    if (existingUser.length > 0) {
      // Email is already in use, provide an option to link Google account
      return {
        success: false,
        message: 'Email already in use by another account. Would you like to link your Google account?',
        linkOption: true,
      };
    }

    // Proceed with registration if email is not in use
    const userCredential = await this.props.firebase.auth.createUserWithEmailAndPassword(email, password);
    const user = userCredential.user;

    // Update user profile
    await user.updateProfile({ displayName });

    // Create wallet for the user
    // ...

    return {
      success: true,
      message: 'Registration successful. Wallet created.',
    };
  };

  formValidate(fieldName, value) {
    let { formErrors, fieldsTouched } = this.state;
    value = value + '';

    switch (fieldName) {
      case "userID":
        formErrors.userID = validator.isEmpty(value) ? "Username is required." : null;
        formErrors.email = validator.isEmpty(value)
          ? "Email is required."
          : !validator.isEmail(value)
            ? "Email is not valid."
            : null;
        break;
      case "password":
        formErrors.password = !validator.isStrongPassword(value, { minLength: 5, minUppercase: 1, minNumbers: 1, minLowercase: 0, minSymbols: 0 })
          ? "Password must contain min 5 chars and one uppercase and one number. ex- sD2ww"
          : null;
        break;
      case "confirm_password":
        formErrors.confirm_password = validator.isEmpty(value)
          ? "Confirm Password is required."
          : !validator.equals(value, String(this.state.user.password))
            ? "Password and Confirm Password didn't match."
            : null;
        break;
      case "name":
        formErrors.name = validator.isEmpty(value) ? "Name is required." : null;
        break;
      case "phone":
        formErrors.phone = validator.isEmpty(value)
          ? "Phone is required."
          : !validator.isMobilePhone(value)
            ? "Phone is not valid."
            : null;
        break;
      case "address":
        formErrors.address = validator.isEmpty(value) ? "Address is required." : null;
        break;
      case "paymentID":
        formErrors.paymentID = validator.isEmpty(value) ? "Payment ID is required." : null;
        break;
      default:
        break;
    }

    const isValidForm = Object.values(formErrors).every((error) => !error);
    // console.log("isvalidFrom: " + isValidForm);

    const formTouched = fieldsTouched.length === 5;
    this.setState({ formErrors, isValidForm, formTouched });
  };


  async handleSubmit(event) {
    event.preventDefault();
    const { firebase } = this.props;
    const { email, password, name, phone, address, paymentID, userID } = this.state.user;

    this.setState({ isLoading: true });
    console.log();
    try {
      // Check if the email is already in use
      //console.log("Email: " + email);
      const existingUser = await firebase.checkIfEmailExists(email);
      //console.log("existingUserCheck: " + existingUser);
      if (existingUser) {
        // Email is already in use, provide an option to link Google account
        // return {
        //   success: false,
        //   message: 'Email already in use by another account. Would you like to link your Google account?',
        //   linkOption: true,
        // };
        //this.handleLinkGoogleAccount(email)
        toast.success("User already exists just needs a wallet");
        this.setState({ isLoading: false, isSuccessResponse: true });
      } else {
        // Create user with Firebase
        const userCredential = await firebase.auth.createUserWithEmailAndPassword(email, password);
        console.log("here0");
        const firebaseUser = userCredential.user;
        let userType = "AH"; //or TRD for trader
        await firebaseUser.updateProfile({
          displayName: name,
          phoneNumber: phone
        });
        console.log("here1");
        // Save user data to Firestore or Realtime Database
        await firebase.db.ref(`users/${firebaseUser.uid}`).set({
          email,
          name,
          phone,
          address: "TBD",
          paymentID: "0",
          userID,
          password,
          userType,
          mieWalletExists: true,
          mieUserID: firebaseUser.uid,
          verified: false,
        });

        console.log("here2");
        // Send email verification with a unique link
        const actionCodeSettings = {
          //url: `http://localhost:3000/verify-email?uid=${firebaseUser.uid}`,
          //url: `https://mie.mieros.cloud/verify-email?uid=${firebaseUser.uid}`,
          //url: API_ENDPOINT + `/verify-email?uid=${firebaseUser.uid}`,
          handleCodeInApp: true,
        };
        // await firebase.doSendEmailVerification(actionCodeSettings);
        // //console.log("here03:");
        // toast.success("Verification email sent. Please check your inbox.", {
        //   autoClose: 3000,
        //   hideProgressBar: false,
        //   pauseOnHover: false,
        //   pauseOnFocusLoss: false,
        // });

        this.setState({ isLoading: false, isSuccessResponse: true });
      }//EOE


    } catch (err) {
      toast.error(`Failed to submit: ${err.message}`, {
        autoClose: 30000
      });
      this.setState({
        isLoading: false,
        isSuccessResponse: false,
        errorResponse: err.message,
        formTouched: false,
        isValidForm: false,
        confirmPassword: null
      });
    }
  };

  componentWillUnmount() { }

  renderContentOld() {
    return (
      <div className="register-form vh-100 d-flex text-center">
        <video className="video-background" src={mierosVideo} autoPlay muted loop />
        <form className="form-create-account shadow" id="formAccount" onSubmit={this.handleSubmit} noValidate>

          <img className="site-logo mb-4" src={logo} alt="{SITE_NAME}" />

          <div className="row">
            <div className="col-md-12 mb-1">
              <label htmlFor="username">Email</label>
              <input type="text" className="form-control" id="username" name="userID" value={this.state.user.userID || ''} onChange={this.handleChange} onClick={this.handleChange} required />
              <div className="text-danger">{this.state.formErrors.userID}</div>
            </div>
            <div className="col-md-12 mb-1">
              <label htmlFor="password">Wallet Password</label>
              <input type="password" className="form-control" id="password" name="password" onChange={this.handleChange} onClick={this.handleChange} required />
              <div className="text-danger">{this.state.formErrors.password}</div>
            </div>
            <div className="col-md-12 mb-1">
              <label htmlFor="confirm_password">Confirm Password</label>
              <input type="password" className="form-control" id="confirm_password" name="confirm_password" onChange={this.handleChange} onClick={this.handleChange} required />
              <div className="text-danger">{this.state.formErrors.confirm_password}</div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mb-1">
              <label htmlFor="name">Contact Name</label>
              <input type="text" className="form-control" id="name" name="name" value={this.state.user.name || ''} onChange={this.handleChange} onClick={this.handleChange} required />
              <div className="text-danger">{this.state.formErrors.name}</div>
            </div>
            {/* <div className="col-md-6 mb-1">
              <label htmlFor="email">Email Address</label>
              <input type="email" className="form-control" id="email" name="email" value={this.state.user.email || ''} onChange={this.handleChange} onClick={this.handleChange} required />
              <div className="text-danger">{this.state.formErrors.email}</div>
            </div> */}
            <input type="hidden" id="email" name="email" value={this.state.user.email || ''} />

          </div>
          <div className="row">
            <div className="col-md-12 mb-1">
              <label htmlFor="phone">Phone</label>
              <input type="tel" className="form-control" id="phone" name="phone" value={this.state.user.phone || ''} onChange={this.handleChange} onClick={this.handleChange} required />
              <div className="text-danger">{this.state.formErrors.phone}</div>
            </div>
            {/* <div className="col-md-6 mb-1">
              <label htmlFor="address">Address</label>
              <input type="text" className="form-control" id="address" name="address" value={this.state.user.address || ''} onChange={this.handleChange} onClick={this.handleChange} required />
              <div className="text-danger">{this.state.formErrors.address}</div>
            </div> */}
            <input type="hidden" id="address" name="address" value={this.state.user.address || 'TBD'} />

          </div>
          <hr />
          <div className="row">
            {/* <div className="col-md-12 mb-1">
              <label htmlFor="paymentID">Payment ID</label>
              <input type="text" className="form-control" id="paymentID" name="paymentID" value={this.state.user.paymentID || ''} onChange={this.handleChange} onClick={this.handleChange} required />
              <div className="text-danger">{this.state.formErrors.paymentID}</div>
            </div> */}
            <input type="hidden" id="paymentID" name="paymentID" value={this.state.user.paymentID || '0'} />

          </div>
          <button className="btn btn-primary btn-block my-1" type="submit" disabled={this.state.isValidForm && this.state.formTouched ? false : true}>
            Sign Up
            {this.state.isLoading && <SpinnerButton />}
          </button><br />
          <Link to="/login">Back to Sign In</Link>
          <Footer />
        </form>
        <ToastContainer />
      </div>
    )
  }

  renderContent() {
    return (
      <div className="register-form vh-100 d-flex justify-content-center align-items-center">
        <video className="video-background" src={mierosVideo} autoPlay muted loop />
        <CCard className="shadow" style={{ backgroundColor: 'white', width: '500px', height: 'auto' }}>
          <CCardBody>
            <div className="text-center mt-3">
              <img className="site-logo mb-4" src={logo} alt="{SITE_NAME}" style={{ maxWidth: '50%', height: 'auto', borderRadius: '50%' }} />
            </div>
            <CForm id="formAccount" onSubmit={this.handleSubmit} noValidate>
              <CRow>
                <CCol md={12} className="mb-1">
                  <CFormLabel htmlFor="username">Email</CFormLabel>
                  <CFormInput
                    type="text"
                    id="username"
                    name="userID"
                    value={this.state.user.userID || ''}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    required
                  />
                  <div className="text-danger">{this.state.formErrors.userID}</div>
                </CCol>
                <CCol md={12} className="mb-1">
                  <CFormLabel htmlFor="password">Wallet Password</CFormLabel>
                  <CFormInput type="password" id="password" name="password" onChange={this.handleChange} required />
                  <div className="text-danger">{this.state.formErrors.password}</div>
                </CCol>
                <CCol md={12} className="mb-1">
                  <CFormLabel htmlFor="confirm_password">Confirm Password</CFormLabel>
                  <CFormInput type="password" id="confirm_password" name="confirm_password" onChange={this.handleChange} required />
                  <div className="text-danger">{this.state.formErrors.confirm_password}</div>
                </CCol>
              </CRow>
              <CRow>
                <CCol md={12} className="mb-1">
                  <CFormLabel htmlFor="name">Contact Name</CFormLabel>
                  <CFormInput type="text" id="name" name="name" value={this.state.user.name || ''} onChange={this.handleChange} required />
                  <div className="text-danger">{this.state.formErrors.name}</div>
                </CCol>
                <input type="hidden" id="email" name="email" value={this.state.user.email || ''} />
              </CRow>
              <CRow>
                <CCol md={12} className="mb-1">
                  <CFormLabel htmlFor="phone">Phone</CFormLabel>
                  <CFormInput type="tel" id="phone" name="phone" value={this.state.user.phone || ''} onChange={this.handleChange} required />
                  <div className="text-danger">{this.state.formErrors.phone}</div>
                </CCol>
                <input type="hidden" id="address" name="address" value={this.state.user.address || 'TBD'} />
              </CRow>
              <hr />
              <input type="hidden" id="paymentID" name="paymentID" value={this.state.user.paymentID || '0'} />
              <div className="row">
                <CButton color="primary" className="btn btn-primary btn-block my-1" type="submit" disabled={!this.state.isValidForm || !this.state.formTouched}>
                  Sign Up
                  {this.state.isLoading && <SpinnerButton />}
                </CButton>
                <br />
                <div className="text-center w-100 mt-2">
                  <Link to="/login">Back to Sign In</Link>
                </div>
              </div>
              <Footer />
            </CForm>
          </CCardBody>
        </CCard>
        <ToastContainer />
      </div>
    )
  }


  render() {
    if (this.users.isUserLogin()) {
      return <Navigate to="/" replace={true} />;
    }
    if (this.state.isSuccessResponse) {
      return <Navigate to="/login" replace={true} />;
    }

    return this.renderContent();
  }
}//EOC

export default withFirebase(CreateAccount);
